import rendezvenyekService from '../rendezvenyek-service';
import 'desandro-matches-selector';
import 'ev-emitter';
import 'imagesloaded';
import 'fizzy-ui-utils';
import 'get-size';
import 'outlayer/item';
import 'outlayer';
import 'masonry-layout';
import 'ng-masonry';
const MODULE_NAME = 'rendezvenyekReszletes';
class RendezvenyekReszletesController {}

export default angular.module(MODULE_NAME, [rendezvenyekService, 'ngMasonry'])
	.controller('rendezvenyekReszletesController', RendezvenyekReszletesController).name;



// WEBPACK FOOTER //
// ./source/applications/rendezvenyek/rendezvenyek-reszletes/rendezvenyek-reszletes.js